import { cn } from '@/utils';

interface ActorDataProps {
    className?: string;
    data: {
        integration_idn: string;
        connector_idn: string;
        external_id: string;
        contact_information: string;
        [key: string]: unknown;
    };
}

const ActorData = ({ className, data }: ActorDataProps) => {
    return (
        <div className={cn('overflow-hidden text-xs', className)}>
            <div className="truncate">
                {data.connector_idn
                    ? `${data.integration_idn} / ${data.connector_idn}`
                    : data.integration_idn}
            </div>
            {data.external_id ? (
                <div className="truncate">
                    External Id: &nbsp;&nbsp; {data.external_id}
                </div>
            ) : undefined}
            {data.contact_information ? (
                <div className="truncate">
                    Contact Info: {data.contact_information}
                </div>
            ) : undefined}
        </div>
    );
};

export default ActorData;
